export function scrollToFilters() {
    let containersClass = ["blog-container", "products-listing", "posts-block"];
    let $container;
    let url = document.location.href;
    let queryParams = url.substring(url.indexOf("?") + 1).split("&");
    let result = [];
    let $adminBar = $("#wpadminbar");
    // category container
    let productType = "product-type";
    let $productTypePanel = $(".type-filter");

    for (let i = 0; i < queryParams.length; i++){
        queryParams[i] = queryParams[i].split("=");

        if (decodeURIComponent(queryParams[i][1]) != undefined && decodeURIComponent(queryParams[i][1]) != "undefined") {
            result[queryParams[i][0]] = decodeURIComponent(queryParams[i][1]);
        }
    }

    for (let i = 0; i < containersClass.length; i++) {
        if ( $("." + containersClass[i]).length ) {
            $container = $("." + containersClass[i]);
            break;
        }
    }

    if ($container && $container.length && Object.keys(result).length) {
        // if select category without filter
        if (Object.keys(result)[0] === productType && Object.keys(result).length === 1) {
            $container = $productTypePanel;
        }
        window.setTimeout( function () {
            let top = $container.offset().top;
            let headerHeight = $(".header").height();
            let adminBarHeight = 0;
            let containerPadding = 0;

            if ($adminBar.length) {
                adminBarHeight = $adminBar.height();
            }

            if ($container.hasClass("posts-block")) {
                containerPadding = Number($container.css("padding-top").slice(0, -2));
            }

            $("body, html").animate({
                scrollTop: top - headerHeight - adminBarHeight + containerPadding
            }, "300" );
        }, 10 );
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToFilters.js